import React, { useMemo } from 'react';
import UserMetaDataEdit from '../../../Meta/Components/UserMetaDataEdit/UserMetaDataEdit';
import { useAppContext } from '../../../../Services/AppContext';
import { MetaDataItem } from '../../../Manager/Components/Workers/TherapistDetail/TherapistDetail';
import { useWorkerInformationQuery } from '../../../../graphql/graphql';
import Loading from '../../../../Components/Loading';
import useNotification from '../../../../Hooks/useNotification.hook';

interface Props {
	onSave: () => void;
}

const P1DoctorSetup: React.FC<Props> = ({ onSave }) => {
	const { userData } = useAppContext();
	const { data, isLoading, refetch } = useWorkerInformationQuery({
		userId: userData.id,
	});
	const { showNotificationSuccess } = useNotification();

	const meta = useMemo(() => {
		const metas: Record<string, any> = {};
		data?.user?.meta?.forEach(({ key, value }: any) => {
			metas[key] = value;
		});
		return metas;
	}, [data]);

	const metaItem: MetaDataItem = {
		title: 'component.p1DoctorSetup.medicalWorkerNumber',
		printValue: meta?.npwz,
		value: meta?.npwz,
		key: 'npwz',
	};

	const handleOnSuccess = () => {
		showNotificationSuccess({ content: 'base.saved' });
		refetch();
		onSave();
	};

	if (isLoading) {
		return <Loading />;
	}

	return (
		<UserMetaDataEdit
			userId={userData.id}
			metaDataItem={metaItem}
			onSuccess={handleOnSuccess}
		/>
	);
};

export default P1DoctorSetup;
